import React from "react"
import { Stack } from "components/kit"

export default ({ children }) => (
  <Stack spacing="3" direction="col">
    {children}
  </Stack>
)
